import { Document, FeedRoom } from "../../../../../models"

export interface DocumentResponse extends Document {
    lastCommentedTime: string,
    lastModifiedTime: string,
    lastCommentPreview: any,
    lastCommentAuthorUid: any,
    lastCommentAttachmentType?: string | 'default' | null
    source: string,
    tags: string[]
}

export const proccessSingleDocResponse = (response: DocumentResponse): FeedRoom => {
    const year = new Date(response.lastCommentedTime).getFullYear()
    return {
        document: {
            title: response.title,
            dataType: response.dataType,
            source: response.source,
            mimeType: response.mimeType,
            docId: response.docId,
            tags: response.tags ?? response.taggedUsers,
            commentsCounter: response.commentsCounter
        },
        docId: response.docId,
        commentTime: year <= 2014 ? response.lastModifiedTime : response.lastCommentedTime,
        commentText: response.lastCommentPreview,
        commentType: null,
        newComments: 0,
        lastUserId: response.lastCommentAuthorUid,
        chatType: 'Discussions',
        userProfile: null,
        lastCommentAttachmentType: response.lastCommentAttachmentType,
        chat: {            
            chatUId: ''
        }
    }
}

export const proccessSingleDocResponseNew = (response: any): FeedRoom => {
    return {
        document: {
            title: response.document.title,
            dataType: response.document.dataType,
            source: response.document.source,
            mimeType: response.document.mimeType,
            docId: response.docId,
            tags: response.document.tags ?? response.document.taggedUsers,
            commentsCounter: response.document.commentsCounter
        },
        docId: response.docId,
        commentTime: response.commentTime,
        commentText: response.commentText,
        commentType: null,
        newComments: response.newComments ?? 0,
        lastUserId: response.lastUserId,
        chatType: 'Discussions',
        userProfile: null,
        lastCommentAttachmentType: response.lastCommentAttachmentType ?? 'default',
        chat: {            
            chatUId: ''
        }
    }
}

export const processDocsResponse = (documentsResponse: DocumentResponse[]): FeedRoom[] => {
    return documentsResponse.map(proccessSingleDocResponse)
}
export const processDocsResponseNew = (documentsResponse: any[]): FeedRoom[] => {
    return documentsResponse.map(proccessSingleDocResponseNew)
}